import './App.css';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './LoginPage';
import DailySaleSummery from './Report/DailySaleSummery';
import ReceiptSummery from './Report/ReceiptSummery';
import PaymentPendingSummery from './Report/PaymentPendingSummery';
import AssignMineToUser from './Transactions/AssignMineToUser';
import PaymentReceive from './Transactions/PaymentReceive';
import ExpensesEntry from './Transactions/ExpensesEntry';
import OpeningBalance from './Transactions/OpeningBalance';
import UserMaster from './Masters/UserMaster';
import MineMaster from './Masters/MineMaster';
import ProductMaster from './Masters/ProductMaster';
import RateMaster from './Masters/RateMaster';
import CustomerMaster from './Masters/CustomerMaster';
import Dashboard from './Dashboard';
import AdminNavbar from './Navbar/AdminNavbar';
import UserNavbar from './Navbar/UserNavbar';
import BillingEntry from './Transactions/BillingEntry';
import BranchMaster from './Masters/BranchMaster';
import EmployeeMaster from './Masters/EmployeeMaster';
import EmployeeExpense from './Transactions/EmployeeExpense';
import EmployeeExpenseSummary from './Report/EmployeeExpenseSummary';
import ExpensesEntrySummary from './Report/ExpensesEntrySummary';
import PaymentRecieveSummary from './Report/PaymentRecieveSummary';
import PayBasic from './Report/PayBasic';
import ChangePassword from './ChangePassword';
import TitleNavbar from './Navbar/TitleNavbar';


function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/nav-1" element={<AdminNavbar />} />
      <Route path="/nav-2" element={<UserNavbar />} />
      <Route path="/pass"  element={<ChangePassword/>}/>
      <Route path="/nav-3" element={<TitleNavbar />} />


{/* ====================MASTERS===================== */}
      <Route path="/m-1" element={<UserMaster />} />
      <Route path="/m-2" element={<MineMaster />} />
      <Route path="/m-3" element={<ProductMaster />} />
      <Route path="/m-4" element={<RateMaster />} />
      <Route path="/m-5" element={<CustomerMaster />} />
      <Route path="/m-6" element={<EmployeeMaster />} />
      <Route path="/m-7" element={<BranchMaster />} />

{/* ====================TRANSACTIONS===================== */}
      <Route path="/trans-1" element={<AssignMineToUser />} />
      <Route path="/trans-2" element={<BillingEntry />} />
      <Route path="/trans-3" element={<PaymentReceive />} />
      <Route path="/trans-4" element={<ExpensesEntry />} />
      <Route path="/trans-5" element={<EmployeeExpense />} />
      <Route path="/trans-6" element={<OpeningBalance />} />

{/* ====================REPORTS===================== */}
      <Route path="/r-1" element={<DailySaleSummery />} />
      <Route path="/r-2" element={<ReceiptSummery />} />
      <Route path="/r-3" element={<PaymentPendingSummery />} />
      <Route path="/r-4" element={<EmployeeExpenseSummary />} />
      <Route path="/r-5" element={<ExpensesEntrySummary />} />
      <Route path="/r-6" element={<PaymentRecieveSummary />} />
      <Route path="/r-7" element={<PayBasic />} />
    
      

      </Routes>
      </>
  );
}

export default App;
